import { useEffect, useState } from "react";
import { getAuthData } from "../auth/session.js";
import { getCaseRewardImage } from "../cases/reward-assets.js";
import { selectShopRewardPreview } from "./reward-preview.js";

const previewIds = { light: "free", limited: "standard", mystic: "rare" };
const number = value => value.toLocaleString("ru-RU");

/** Shop presentation using the existing, read-only case preview endpoint. */
export function ShopCaseBanner({ caseItem, balance, busy, pending, onPurchase }) {
  const [rewards, setRewards] = useState(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const auth = getAuthData();
    setRewards(null);
    setFailed(false);
    if (!auth) {
      setFailed(true);
      return;
    }
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    let disposed = false;
    fetch("/api/cases/preview", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ initData: auth, caseId: previewIds[caseItem.id] }),
      signal: controller.signal,
    }).then(async response => {
      if (!response.ok) throw new Error("Case preview unavailable");
      const result = await response.json();
      if (!Array.isArray(result.possibleRewards) || !result.possibleRewards.length) {
        throw new Error("Empty case preview");
      }
      if (!disposed) setRewards(result.possibleRewards);
    }).catch(() => {
      if (!disposed) setFailed(true);
    }).finally(() => window.clearTimeout(timeout));
    return () => {
      disposed = true;
      controller.abort();
      window.clearTimeout(timeout);
    };
  }, [caseItem.id, attempt]);

  return <article className={`mc-shop-case mc-shop-case--${caseItem.id}`} aria-label={`Кейс ${caseItem.title}`}>
    <div className="mc-shop-case-art"><img src={caseItem.image} alt={`Кейс ${caseItem.title}`} /></div>
    <div className="mc-shop-case-content">
      <h3>{caseItem.title}</h3>
      {rewards ? <ul className="mc-shop-rewards" aria-label={`Возможные награды ${caseItem.title}`}>
        {selectShopRewardPreview(caseItem.id, rewards).slice(0, 6).map(reward => {
          const image = getCaseRewardImage(reward.rewardType, reward.rarity, reward.label);
          const amount = Number.parseInt(reward.label, 10);
          const label = Number.isFinite(amount) ? number(amount) : reward.label;
          return <li key={reward.label} className={`mc-shop-reward mc-shop-reward--${reward.rarity}`} title={`${reward.title}: ${label}`}>
            {image ? <img src={image} alt="" loading="lazy" /> : <span className="mc-shop-reward-icon" aria-hidden="true">{reward.icon}</span>}
            <b>{label}</b><span className="mc-shop-reward-name">{reward.title}</span>
          </li>;
        })}
      </ul> : <div className="mc-shop-rewards-status" role="status">
        {failed ? <>Состав не загрузился<button type="button" onClick={() => setAttempt(value => value + 1)}>Повторить</button></> : "Загружаем награды…"}
      </div>}
    </div>
    <div className="mc-shop-case-actions">
      {[1, 10].map(amount => {
        const price = caseItem.price * amount;
        const insufficient = balance < price;
        const isPending = pending === `case:${caseItem.id}:${amount}`;
        return <button type="button" key={amount} disabled={busy} onClick={() => onPurchase(amount)}
          aria-label={`${insufficient ? "Пополнить баланс для покупки" : "Купить"} ${caseItem.title}, ${amount} шт., за ${number(price)} MetaCoin`}>
          <span>{isPending ? "Покупаем…" : `×${amount}`}</span>
          <strong><img src="/assets/resource-emojis/coin.webp" width="19" height="19" alt="" aria-hidden="true" />{number(price)}</strong>
        </button>;
      })}
    </div>
  </article>;
}
